export default class FileUtils {
    /**
     * Format a number of bytes into a readable string
     *
     * @param {number} input - number of bytes
     * @returns {string} human-readable string
     */
    static formatBytes(input) {
        if (input === 0) {
            return "0 Bytes";
        }
        const k = 1024;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const i = Math.floor(Math.log(input) / Math.log(k));
        return parseFloat((input / Math.pow(k, i)).toFixed(0)) + " " + sizes[i];
    }
    /**
     * Get the extension from a filename.  For example: file.pdf -> pdf, document.doc -> doc, attachment.service.js -> js
     *
     * @param {string} fileName - name of the file
     * @returns {string} - the extension of the file, or "" if there is no extension
     */
    static getExtension(fileName) {
        let extension = "";
        const indexOfPeriod = fileName.lastIndexOf(".");
        if (indexOfPeriod !== -1) {
            extension = fileName.substring(indexOfPeriod + 1);
        }
        return extension;
    }
    static removeExtension(fileName) {
        return fileName.replace(/\.[^/.]+$/, "");
    }
}
